import { Link } from "react-router-dom";
import Footer from "@/components/Footer";
import Header from "@/components/Header";

const RefundPolicy = () => {
  return (
    <div className="min-h-screen bg-background flex flex-col">
      <Header />

      {/* Main Content */}
      <main className="flex-1 py-16 md:py-24 px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl mx-auto">
          {/* Page Header */}
          <h1 className="font-manrope font-bold text-3xl md:text-4xl text-foreground mb-8">
            Refund Policy
          </h1>

          {/* Content */}
          <div className="prose prose-stone max-w-none">
            <p className="text-lg text-foreground leading-relaxed mb-8">
              We want you to feel confident exploring Relocation Clarity.
            </p>

            <p className="text-foreground leading-relaxed mb-8">
              If you're not satisfied with your purchase, you may request a refund within 7 days of purchase.
            </p>

            {/* What qualifies */}
            <h2 className="font-manrope font-semibold text-xl text-foreground mt-10 mb-4">
              What qualifies
            </h2>
            <ul className="space-y-2 text-foreground mb-8">
              <li className="flex items-start gap-2">
                <span className="text-muted-foreground">•</span>
                <span>One-time purchases, such as a personalized Relocation Blueprint</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-muted-foreground">•</span>
                <span>Requests made within 7 days of purchase</span>
              </li>
            </ul>

            {/* What to know */}
            <h2 className="font-manrope font-semibold text-xl text-foreground mt-10 mb-4">
              What to know
            </h2>
            <ul className="space-y-2 text-foreground mb-8">
              <li className="flex items-start gap-2">
                <span className="text-muted-foreground">•</span>
                <span>Relocation Clarity provides planning guidance and general information only.</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-muted-foreground">•</span>
                <span>We do not provide legal, tax, or immigration advice.</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-muted-foreground">•</span>
                <span>Refunds are intended to support good-faith exploration of the service.</span>
              </li>
            </ul>

            {/* How to request */}
            <h2 className="font-manrope font-semibold text-xl text-foreground mt-10 mb-4">
              How to request a refund
            </h2>
            <ul className="space-y-2 text-foreground mb-10">
              <li className="flex items-start gap-2">
                <span className="text-muted-foreground">•</span>
                <span>
                  Contact us using the{" "}
                  <Link to="/contact" className="text-primary hover:underline">
                    link in the footer
                  </Link>
                </span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-muted-foreground">•</span>
                <span>Include the email address used for your purchase</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-muted-foreground">•</span>
                <span>We'll review and respond promptly</span>
              </li>
            </ul>

            {/* Closing */}
            <p className="text-foreground leading-relaxed border-t border-border pt-8 mt-10">
              We believe clarity should feel helpful — not risky.
            </p>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default RefundPolicy;
